import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./navbar.css";
import logo from "../../assets/triplette-logo.png"

function Navbar() {
    const [isSticky, setSticky] = useState(false);
    const location = useLocation();
    const [isNavbarOpen, setNavbarOpen] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        setNavbarOpen(false); // Close navbar on route change
    }, [location.pathname]);

    useEffect(() => {
        const handleScroll = () => {
            setSticky(window.scrollY > 100);
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <nav className={`navbar navbar-expand-lg ${isSticky ? "fixed" : ""}`} style={{ background: "transparent", color: "black" }}>
            <div className="container">
                <div className="image-container">
                   <Link to = "/"> <img src={logo} width={143} height={47} alt="Logo" /></Link> 
                </div>

                {/* Navbar Toggle Button */}
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-expanded={isNavbarOpen}
                    style={{ background: "#FFA800" }}
                    onClick={() => setNavbarOpen(!isNavbarOpen)}
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* Navbar Menu */}
                <div className={`collapse navbar-collapse ${isNavbarOpen ? "show" : ""}`} id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item"><Link className="nav-link active" to="/" onClick={() => setNavbarOpen(false)}>Home</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="/aboutmain" onClick={() => setNavbarOpen(false)}>About Us</Link></li>
                        {/* <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown">
                                Our Services
                            </a>
                            <ul className="dropdown-menu">
                            <li><Link className="dropdown-item" to="/products/job-placement-assistance" onClick={() => setNavbarOpen(false)}>Job Placement Assistance</Link></li>
                            <li><Link className="dropdown-item" to="/products/resume-building" onClick={() => setNavbarOpen(false)}>Resume Building</Link></li>
                            <li><Link className="dropdown-item" to="/products/interview-preparation" onClick={() => setNavbarOpen(false)}>Interview Preparation</Link></li>
                            <li><Link className="dropdown-item" to="/products/career-counseling" onClick={() => setNavbarOpen(false)}>Career Counseling</Link></li>
                            <li><Link className="dropdown-item" to="/products/-skill-enhancement-programs" onClick={() => setNavbarOpen(false)}>Skill Enhancement Programs</Link></li>
                            <li><Link className="dropdown-item" to="/products/corporate-tie-ups" onClick={() => setNavbarOpen(false)}>Corporate Tie-Ups</Link></li>
                           

                            </ul>
                        </li> */}
                        <li className="nav-item"><Link className="nav-link" to="/products" onClick={() => setNavbarOpen(false)}>Services</Link></li>

                        {/* <li className="nav-item"><Link className="nav-link" to="/policy" onClick={() => setNavbarOpen(false)}>Why Choose</Link></li> */}
                        <li className="nav-item"><Link className="nav-link" to="/carrer" onClick={() => setNavbarOpen(false)}>Career</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="/contact" onClick={() => setNavbarOpen(false)}>Contact Us</Link></li>
                    </ul>
                    {/* <form className="d-flex justify-content-center">
                        <button className="btn btn-outline-success" >Call Us</button>
                    </form> &nbsp;
                    <form className="d-flex justify-content-center">
                        <button className="btn btn-outline-success" >Email Us</button>
                    </form> */}
                    <div className="button-details">
                        <a href="tel:8072712418" className="btn get-button">Call Us</a>
                        <a href="mailto:info@triplette.in" className="btn get-button">Email Us</a>
                        <a
                            href="https://wa.me/918072712418"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn get-button"
                        >
                            WhatsApp
                        </a>
                    </div>


                </div>
            </div>
        </nav>
    );
}

export default Navbar;
